import { apiService } from '.';
import {
    Account,
    AccountFilter,
    AccountHabeasDataHistory,
    AccountHistorical,
} from '../shared/types/modules/account';

export const asyncGetAccounts = async (
    filters: AccountFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Account[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Account[]; length: number };
        } = await apiService.get('/api/account', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetAccount = async (
    idAccount: string
): Promise<Account | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Account;
        } = await apiService.get(`/api/account/${idAccount}`);

        return data;
    } catch (error) {}
};

export const asyncCreateAccount = async (
    account: Account
): Promise<Account | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Account;
        } = await apiService.post('/api/account', account);

        return data;
    } catch (error) {}
};

export const asyncUpdateAccount = async (
    id: string,
    account: Account
): Promise<Account | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Account;
        } = await apiService.patch(`/api/account/${id}`, account);

        return data;
    } catch (error) {}
};

export const asyncGetAccountAcceptsHabeasDataHistory = async (
    page?: number,
    pageSize?: number
): Promise<{
    items: {
        created_at: Date;
        changes: { contactType: { acceptsHabeasData: boolean } };
    }[];
    length: number;
}> => {
    try {
        const {
            items: data,
        }: {
            items: { items: AccountHabeasDataHistory[]; length: number };
        } = await apiService.get('/api/account/accepts-habeas-data-history', {
            limit: pageSize || 20,
            page: page || 0,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetAccountHistorical = async (
    idAccount: string
): Promise<AccountHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: AccountHistorical[];
        } = await apiService.get(`/api/account/${idAccount}/historical`);

        return data;
    } catch (error) {}
};
